/* pg-theme-css */
(function(){
    if (window.pgSearch) return; window.pgSearch = 1;
    var ALLOW = ['handheld-game-console', 'data-frog-protective-bag-for-r36s-retro-video-game-bags-olig-cover-case-for-rg35xx-r35s', 'pokemon-crystal-ball-3d-pikachu-gengar-mewtwo-night-light-lamp-pokeball-3d-glass-pokemon-crystal-ball-statue-kids-birthday-gift'];
    function widget(){
      document.querySelectorAll('.pgh-head-in > a[aria-label="Search"], .pgx-head-in > a[aria-label="Search"], .pgc-head-in > a[aria-label="Search"]').forEach(function(a){
        var w = document.createElement('div');
        w.className = 'pg-search';
        w.innerHTML = '<svg viewBox="0 0 24 24"><circle cx="11" cy="11" r="7"/><path d="M20 20l-4.2-4.2"/></svg>'
          + '<input type="text" placeholder="Search" aria-label="Search products">'
          + '<div class="pg-search-dd"></div>';
        var hostIn = a.closest('.pgh-head-in,.pgx-head-in,.pgc-head-in');
        var navEl = (hostIn && hostIn.querySelector('nav')) || document.querySelector('.pgx-nav,.pgh-nav,.pgc-nav');
        if (navEl){ navEl.insertBefore(w, navEl.firstChild); a.remove(); } else { a.replaceWith(w); }
        var input = w.querySelector('input');
        var dd = w.querySelector('.pg-search-dd');
        var t;
        input.addEventListener('keydown', function(e){
          if (e.key === 'Enter') e.preventDefault();
          if (e.key === 'Escape'){ dd.classList.remove('on'); input.blur(); }
        });
        input.addEventListener('input', function(){
          clearTimeout(t);
          var q = input.value.trim();
          if (q.length < 2){ dd.classList.remove('on'); dd.innerHTML = ''; return; }
          t = setTimeout(function(){
            fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=10')
              .then(function(r){ return r.json(); })
              .then(function(d){
                var items = ((d.resources && d.resources.results && d.resources.results.products) || []).filter(function(p){
                  return ALLOW.some(function(h){ return (p.url || '').indexOf(h) > -1; });
                });
                if (!items.length){
                  dd.innerHTML = '<div class="pg-search-none">No matching products</div>';
                } else {
                  dd.innerHTML = items.map(function(p){
                    var img = (p.featured_image && p.featured_image.url) || p.image || '';
                    return '<a href="' + p.url + '">'
                      + (img ? '<img src="' + img + '" alt="">' : '')
                      + '<span>' + p.title + '</span>'
                      + (p.price ? '<b>$' + p.price + '</b>' : '')
                      + '</a>';
                  }).join('');
                }
                dd.classList.add('on');
              }).catch(function(){});
          }, 250);
        });
        document.addEventListener('click', function(e){ if (!w.contains(e.target)) dd.classList.remove('on'); });
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', widget); else widget();
    setTimeout(widget, 900);
  })();
;
/* pg-theme-css */
(function(){
    if (window.pgStars) return; window.pgStars = 1;
    var P=[[34,16,0],[62,10,.6],[20,13,1.4],[52,20,2.1],[30,10,.9],[64,15,1.8],[24,11,.3],[50,18,2.6],[34,11,1.1],[58,14,2.9]];
    var cols=['#B478E0','#C9A6E8','#9B4BC4'];
    var lastH=0;
    /* 2026-10-14 (owner: "it feels choppy scrolling"): the page height is the body's own height; the star columns hang outside it (absolute), so nothing is hidden to measure. Hiding them every 1.5 s restarted their 0.6 s fade-in, so on wide screens the side stars blinked out and back every 1.5 s and the page repainted two full-height columns 40% of the time. */
    function docH(){var b=document.body,e=document.documentElement;return Math.max(b.offsetHeight,e.clientHeight);}
    /* SPEED (2026-10-13): the stars are display:none up to 1100px
       (pg-theme-css: @media(max-width:1100px){.pgf-stars{display:none}}), yet
       every phone still built a few hundred hidden <i> on load, at 900ms and
       on every resize (a phone's toolbar showing or hiding fires one), and
       measured the whole document every 1.5s. Below that width nothing is
       built or measured; widening past it fires resize, which builds. */
    function starsOff(){ return !!(window.matchMedia && window.matchMedia('(max-width:1100px)').matches); }
    function build(){
      if (starsOff()) return;
      var H=docH(); lastH=H;
      ['l','r'].forEach(function(cls,side){
        var d=document.querySelector('.pgf-stars.'+cls);
        if(!d){d=document.createElement('div');d.className='pgf-stars '+cls;d.setAttribute('aria-hidden','true');document.body.appendChild(d);}
        d.style.height=H+'px';
        var html='',step=120,n=Math.ceil(H/step);
        for(var i=0;i<n;i++){
          var p=P[(i+side*3)%P.length];
          var top=i*step+((i*37+side*53)%76);
          var left=p[0]+((i*29)%26)-13; if(left<4)left=4; if(left>76)left=76;
          html+='<i style="top:'+top+'px;left:'+left+'%;width:'+p[1]+'px;height:'+p[1]+'px;animation-delay:'+(((i%7)*0.45)+(p[2]%1))+'s;background:'+cols[i%3]+'"></i>';
        }
        d.innerHTML=html;
      });
    }
    function tick(){if(starsOff())return;var H=docH(); if(Math.abs(H-lastH)>200) build();}
    if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',build);else build();
    setTimeout(build,900); setInterval(tick,1500);
    window.addEventListener('resize',function(){setTimeout(build,250);});
  })();
;
/* pg-theme-css */
/* ONE CATALOGUE READ PER PAGE, SHARED BY THIS WHOLE FILE.
   Two blocks below each download /products.json?limit=50 -- yml() for "You may
   also like" and pgDuo's build() for the Duo Pack prices -- and each can do it
   more than once:

     - pgDuo's build() runs on a 2500ms interval and guards on
       `first.dataset.pgSingled`, where `first` is
       document.querySelector('#pgx .pgx-tile'). pgLadder inserts its own
       .pgx-lad tiles BEFORE the theme's first tile, so `first` becomes a ladder
       tile that never carried the flag and the guard misses on the pass right
       after the ladder builds.
     - yml() runs at DOMContentLoaded and again at 1200ms, and its
       `document.querySelector('.pgu-yml')` guard is tested BEFORE its own fetch
       resolves, so the second call can start a second download of the same
       catalogue.

   Measured on the orb page with both blocks live: three downloads of the same
   50-product payload (t=27ms, 30ms, 1017ms) per product page view, on mobile
   data. Sharing one in-flight promise takes it to one, with every DOM outcome
   identical -- ladder tiles, the Bundle & Save label, the "You may also like"
   grid and the singling all unchanged.

   The guard is NOT re-pointed at '#pgx .pgx-tile:not(.pgx-lad)', which is the
   more correct reading of `first` and what pgLadder itself uses: that would also
   MOVE the singling, and today pgDuo strips the radio dot from the first LADDER
   tile, which is what is on screen. Changing which tile loses its dot is a
   visible change nobody asked for.

   A FAILED read clears the cache so callers can retry -- caching a rejected
   promise forever would turn one bad response into a permanently missing Duo
   Pack and no "You may also like". */
(function(){
  if (window.pgCatalog) return;
  var CACHE = null;
  window.pgCatalog = function(){
    if (!CACHE){
      CACHE = fetch('/products.json?limit=50').then(function(r){ return r.json(); });
      CACHE.catch(function(){ CACHE = null; });
    }
    return CACHE;
  };
})();
;
/* pg-theme-css */
(function(){
    if (window.pgWire) return; window.pgWire = 1;
    /* Pop-out cart: refresh the drawer section markup, then slide it out */
    window.pgOpenCart = function(){
      if (window.pgGiftSync) setTimeout(window.pgGiftSync, 60);
      /* openPanel comes from custom-async.js, which loads lazily; the old
         fallback navigated to /cart, which pg-cart-gone bounces straight back,
         so the page reloaded and the drawer never opened. Wait for it instead. */
      var done=function(){ var n=0; (function w(){ if (window.openPanel){ openPanel('cart'); } else if (n++ < 30){ setTimeout(w, 100); } })(); };
      fetch('/?sections=side-cart').then(function(r){return r.json();}).then(function(j){
        var html=j['side-cart']||'';
        var t=document.createElement('div'); t.innerHTML=html;
        var fresh=t.querySelector('#cart'), cur=document.getElementById('cart');
        if(fresh&&cur){cur.innerHTML=fresh.innerHTML;}
        /* SAME CONTRACT AS pgDrawerRefresh. That path announces its swap with
           pg:cart-updated and every drawer section rebuilds on it -- the
           storage picker (pg-cart-variants), the spare-case offer and gift
           cell (pg-cart-tune). This path replaced the same markup silently,
           so a pack added from the product page arrived in the drawer with
           no storage dropdown until some later write happened to fire the
           event. Measured on the Trio Pack: no picker after Add to cart,
           picker within 2.5s of the event being dispatched by hand. */
        try { document.dispatchEvent(new CustomEvent('pg:cart-updated')); } catch(e){}
        done();
      }).catch(done);
    };
    document.addEventListener('click', function(e){
      var a=e.target.closest&&e.target.closest('a[href$="/cart"],a[href*="/cart?"]');
      if(!a)return;
      if(a.closest('#cart'))return;
      e.preventDefault(); e.stopPropagation();
      window.pgOpenCart();
    }, true);
    /* Bottom sticky buy bar on product pages */
    function stickyTick(){
      var atc=document.getElementById('pgx-atc');
      var bar=document.getElementById('pg-sticky');
      if(!atc){ if(bar) bar.classList.remove('on'); return; }
      if(!bar){
        bar=document.createElement('div'); bar.id='pg-sticky';
        bar.innerHTML='<div class="pgst-in"><span class="pgst-t"></span><span class="pgst-p"></span><button type="button" class="pgst-b">Add to cart</button></div>';
        document.body.appendChild(bar);
        bar.querySelector('.pgst-b').addEventListener('click',function(){ atc.click(); });
      }
      var h1=document.querySelector('#pgx h1')||document.querySelector('h1');
      if(h1) bar.querySelector('.pgst-t').textContent=h1.textContent.replace(/\s+/g,' ').trim();
      var sel=document.querySelector('.pgx-tile.pgx-sel')||document.querySelector('.pgx-tile');
      if(sel){
        var m=(sel.textContent.match(/\$[0-9][0-9.,]*/g)||[]);
        var pEl=bar.querySelector('.pgst-p');
        if(m.length){ pEl.innerHTML=(m.length>1?'<s>'+m[1]+'</s>':'')+m[0]; }
      }
      var cart=document.getElementById('cart');
      var open=cart&&/(^|\s)toggle(\s|$)/.test(cart.className);
      var r=atc.getBoundingClientRect();
      var out=(r.width===0&&r.height===0)?(window.pageYOffset>500):(r.bottom<0||r.top>window.innerHeight);
      if(out&&!open){ bar.classList.add('on'); } else { bar.classList.remove('on'); }
    }
    /* Bottom sticky buy bar removed by request. The top 5% OFF cart bar
       (pg-cart-sticky's #pg-cartfab) is the one sticky element that stays.
       stickyTick is kept but never scheduled, and the CSS above pins
       #pg-sticky to display:none in case anything else ever builds it. */
    /* You may also like: every other product, under the gallery stack */
    function yml(){
      var gal=document.querySelector('.pgx-gallery');
      if(!gal||document.querySelector('.pgu-yml'))return;
      var cur=(location.pathname.match(/\/products\/([^\/?#]+)/)||[])[1];
      if(!cur)return;
      window.pgCatalog().then(function(j){
        /* the packs, the case and shipping protection are sold from the
           console page's own tiles and the cart, and their pages redirect,
           so a card for them led nowhere (2026-09-11) */
        var SKIP={'r36s-duo-pack':1,'r36s-trio-pack':1,'r36s-protective-case-free-gift':1,'shipping-protection':1,'flip-sp-silicone-case':1,'flip-sp-hard-shell-case':1,'flip-sp-screen-protector':1,'r36-pro-2-silicone-case':1,'r36-pro-2-hard-shell-case':1,'r36-pro-2-screen-protector':1,'flip-sp-max-kit':1,'r36-pro-2-max-kit':1,'r36h-silicone-case':1,'r36h-hard-shell-travel-case':1,'r36h-ultra-hard-shell-travel-case':1,'r36h-ultra-screen-protector':1,'r36h-ultra-hard-shell-travel-case':1,'r36h-ultra-screen-protector':1,'r36h-screen-protector':1,'r36h-max-kit':1,'r36s-ultra-silicone-case':1,'r36s-ultra-hard-shell-case':1,'r36s-ultra-screen-protector':1,'r36s-ultra-max-kit':1}; /* the Flip SP's two add-on cases are sold from its tiles and the cart, not as catalogue items (2026-09-18) */
        /* 2026-10-14 (owner: "the clear case and hard case should not be in the recommend section"): every add-on (silicone / clear case, hard shell case, screen protector, protection kit) stays out of You may also like, whatever console it belongs to, so new add-ons need no entry above. The Legends Slab Case is a product of its own and stays. */
        var ADDON=/(silicone|hard-shell|screen-protector|max-kit|protective-case|shipping-protection)/;
        var ps=(j.products||[]).filter(function(p){var v=(p.variants&&p.variants[0])||{};return p.handle!==cur&&!SKIP[p.handle]&&!ADDON.test(p.handle)&&p.images&&p.images.length&&parseFloat(v.price||0)>0;});
        if(!ps.length||document.querySelector('.pgu-yml'))return;
        var d=document.createElement('div'); d.className='pgu-yml';
        d.innerHTML='<div class="pgu-yml-eye">Keep exploring</div><h3>You may also like</h3><div class="pgu-yml-grid">'+
          ps.map(function(p){
            var v=(p.variants&&p.variants[0])||{};
            var now=parseFloat(v.price||0), was=parseFloat(v.compare_at_price||0);
            /* the card photo: the R36S Pro shows the in-hands lifestyle shot (the black-gloves Mario Kart photo its own page uses under the price comparison) instead of the six-colour render (2026-09-22, "should be lifestyle photo in hands"); everything else keeps its first image */
            var img=p.images[0]; if(p.handle==='pocket-era-flip-sp'){ img={src:'https://cdn.shopify.com/s/files/1/0815/5706/1860/files/flipsp-yml-gloves-purple.png'}; } /* 2026-10-01 (owner: the Flip card in You may also like "doesn't match the purple theme of the others"): the Flip's card reads the purple-castle render kept in Files (its gallery leads with a red console on a wooden desk) */ if(p.handle==='pocket-era-r36-pro-2'){ var pgPro=null, pgMk=null; p.images.forEach(function(im){ if(!im||!im.src) return; if(im.src.indexOf('r36s-pro-gloves-purple')>-1) pgPro=im; if(im.src.indexOf('Mario_Kart_2_FINISHED')>-1) pgMk=im; }); img=pgPro||{src:'https://cdn.shopify.com/s/files/1/0815/5706/1860/files/r36s-pro-gloves-purple.jpg?v=1790525586&width=720'}; /* 2026-09-28: the gallery went back to the old renders and this photo left the product, so the card reads the file straight from the CDN */ /* 2026-09-27 (owner: the R36S Pro card "doesn't match the purple theme the others have"): the black-gloves Mario Kart shot re-staged on the purple lavender desk, the Mario Kart photo as the fallback */ }
            return '<a href="/products/'+p.handle+'"><img loading="lazy" src="'+img.src+'" alt=""><div class="t">'+p.title+'</div><div class="p">'+(was>now?'<s>$'+was.toFixed(2)+'</s>':'')+'$'+now.toFixed(2)+'</div></a>';
          }).join('')+'</div>';
        var main=document.querySelector('#pgx .pgx-main');
        if(main&&main.parentElement){
          var qm=document.querySelector('#pgx .pgx-quote[data-pg-moved]');
          var ref=(qm&&qm.parentElement===main.parentElement)?qm.nextSibling:main.nextSibling;
          main.parentElement.insertBefore(d,ref);
        }else{gal.appendChild(d);}
      }).catch(function(){});
    }
    if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',yml);else yml();
    setTimeout(yml,1200);
  })();
;
/* pg-theme-css */
(function(){
  if (window.pgPayRow) return; window.pgPayRow = 1;
  window.pgDrop = function(opts, initId, onChange){
    var w = document.createElement('div'); w.className = 'pg-drop';
    var head = document.createElement('div'); head.className = 'pg-drop-h';
    var list = document.createElement('div'); list.className = 'pg-drop-l';
    var cur = opts.filter(function(o){ return String(o.id) === String(initId); })[0] || opts[0];
    function setCur(o){
      cur = o; head.innerHTML = '';
      var im = new Image(); im.src = o.img;
      var sp = document.createElement('span'); sp.textContent = o.t;
      var car = document.createElement('b'); car.innerHTML = '&#9662;';
      head.appendChild(im); head.appendChild(sp); head.appendChild(car);
    }
    opts.forEach(function(o){
      var r = document.createElement('div'); r.className = 'pg-drop-r';
      var im = new Image(); im.src = o.img;
      var sp = document.createElement('span'); sp.textContent = o.t;
      r.appendChild(im); r.appendChild(sp);
      r.addEventListener('click', function(e){ e.stopPropagation(); setCur(o); w.classList.remove('on'); if (onChange) onChange(o); });
      list.appendChild(r);
    });
    setCur(cur);
    head.addEventListener('click', function(e){
      e.stopPropagation(); e.preventDefault();
      document.querySelectorAll('.pg-drop.on').forEach(function(d2){ if (d2 !== w) d2.classList.remove('on'); });
      w.classList.toggle('on');
    });
    document.addEventListener('click', function(){ w.classList.remove('on'); });
    w.appendChild(head); w.appendChild(list);
    w.pgValue = function(){ return cur.id; };
    return w;
  };
  function put(){
    if (document.querySelector('.pg-payrow')) return;
    var tpl = document.getElementById('pg-paytpl'); if (!tpl || !tpl.innerHTML) return;
    var foot = document.querySelector('.shopify-section-group-footer-group') || document.getElementById('footer') || document.querySelector('footer');
    if (!foot) return;
    var row = document.createElement('div'); row.className = 'pg-payrow'; row.innerHTML = tpl.innerHTML;
    var all = foot.querySelectorAll('*'), cr = null;
    for (var i = 0; i < all.length; i++){
      var e = all[i];
      if (!e.children.length && /(\u00a9|&copy;|Pocket Era)/i.test(e.textContent) && e.textContent.length < 120){ cr = e; break; }
    }
    if (cr){ var blk = cr.parentElement || foot; blk.parentElement.insertBefore(row, blk); }
    else foot.appendChild(row);
  }
  function subWhite(){
    var sel = document.querySelectorAll('#pgx .pgx-tile.pgx-sel .pgx-tile-sub');
    for (var i = 0; i < sel.length; i++){
      var tile = sel[i].closest('.pgx-tile'); if (!tile) continue;
      var m = (getComputedStyle(tile).backgroundColor || '').match(/\d+/g); if (!m) continue;
      var L = m[0] * .299 + m[1] * .587 + m[2] * .114;
      sel[i].style.setProperty('color', L < 150 ? '#fff' : '#7A2FA2', 'important');
    }
  }
  function paint(){
    var A = 'linear-gradient(90deg,#2E0E44 0%,#6B2894 22%,#C08BE8 50%,#6B2894 78%,#2E0E44 100%)';
    var G = 'linear-gradient(120deg,#9B4BC4 0%,#7A2FA2 30%,#4A1C66 50%,#7A2FA2 70%,#9B4BC4 100%)';
    document.querySelectorAll('.pgh-announce,.pgx-announce,.pgc-announce,.pgf-announce').forEach(function(e){
      if (e.dataset.pgPaint) return; e.dataset.pgPaint = 1;
      e.style.setProperty('background-image', A, 'important');
      e.style.setProperty('background-size', '220% 100%', 'important');
    });
    /* THE WAVE, SLOWER (2026-09-11, by request: "nice but always too dynamic").
       These are the ADD TO CART buttons -- the product page's, the sticky bar's,
       the home cards' and the console tiles' own in pg-r36s-mobile -- and every
       one of them now runs the same 8s cycle (one pass of the highlight every
       4s), where this stamp alone ran 3.2s and the stylesheets 5s. The chips,
       ribbons and badges ("+ FREE Case", the sale badge) run 8s too: the owner
       noticed the tile's FREE Case pill and its ADD TO CART moving together and
       asked for slower, not different, so every pgShiftT on the site keeps one
       duration and they stay in step. */
    document.querySelectorAll('#pgx .pgx-atc,.pgst-b').forEach(function(e){
      if (e.dataset.pgPaint) return; e.dataset.pgPaint = 1;
      e.style.setProperty('background-image', 'linear-gradient(115deg,#C08BE8 0%,#9B4BC4 20%,#7A2FA2 40%,#4A1C66 56%,#7A2FA2 74%,#C08BE8 100%)', 'important');
      e.style.setProperty('background-size', '320% 320%', 'important');
      e.style.setProperty('animation', 'pgShiftT 8s ease-in-out infinite', 'important');
    });
    document.querySelectorAll('#pgx .pgx-guar').forEach(function(e){
      if (e.dataset.pgPaint) return; e.dataset.pgPaint = 1;
      e.style.setProperty('background-image', 'linear-gradient(120deg,#FFFFFF,#F4EAFB)', 'important');
      e.style.setProperty('color', '#7A2FA2', 'important');
    });
  }
  function paintNews(){
    var nf = document.querySelector('.shopify-section[id*="__footer"] form.contact-form');
    if (!nf || nf.dataset.pgPaint) return;
    nf.dataset.pgPaint = 1;
    var wrap = nf.parentElement;
    var bgm = (getComputedStyle(wrap).backgroundColor || '').match(/\d+/g);
    var lum = bgm ? (bgm[0] * .299 + bgm[1] * .587 + bgm[2] * .114) : 255;
    var txt = lum < 120 ? '#FFFFFF' : '#2A1440';
    wrap.querySelectorAll('*').forEach(function(el){
      if (el.tagName === 'IFRAME' || el.closest('[data-shop-follow]')) return;
      el.style.setProperty('background-color', 'transparent', 'important');
      el.style.setProperty('color', txt, 'important');
    });
    var em = nf.querySelector('input[type="email"],input:not([type="submit"])');
    if (em){
      em.style.setProperty('background', '#fff', 'important');
      em.style.setProperty('border', '1.5px solid rgba(122,47,162,.4)', 'important');
      em.style.setProperty('border-radius', '10px', 'important');
      em.style.setProperty('color', '#2A1440', 'important');
    }
    var btn = nf.querySelector('button,[type="submit"]');
    if (btn){
      btn.style.setProperty('background-image', 'linear-gradient(120deg,#9B4BC4 0%,#7A2FA2 30%,#4A1C66 50%,#7A2FA2 70%,#9B4BC4 100%)', 'important');
      btn.style.setProperty('background-color', '#7A2FA2', 'important');
      btn.style.setProperty('background-size', '240% 240%', 'important');
      btn.style.setProperty('animation', 'pgShiftT 8s ease-in-out infinite', 'important');
      btn.style.setProperty('color', '#fff', 'important');
      btn.style.setProperty('border', 'none', 'important');
      btn.style.setProperty('border-radius', '999px', 'important');
      btn.querySelectorAll('*').forEach(function(k){
        k.style.setProperty('color', '#fff', 'important');
        k.style.setProperty('-webkit-text-fill-color', '#fff', 'important');
      });
    }
  }
  function killUsdc(){
    document.querySelectorAll('.pgx-pay svg, .pg-payrow svg, #cart .l4pm svg').forEach(function(sv){
      if (sv.dataset.pgUsdc) return;
      var t = sv.querySelector('title');
      if (t && /usdc/i.test(t.textContent)){ sv.dataset.pgUsdc = 1; sv.style.setProperty('display', 'none', 'important'); var li = sv.closest('li'); if (li) li.style.setProperty('display', 'none', 'important'); }
    });
  }
  function moveQuote(){
    var q=document.querySelector('#pgx .pgx-quote');
    var main=document.querySelector('#pgx .pgx-main');
    if(!q||!main||!main.parentElement||q.dataset.pgMoved)return;
    q.dataset.pgMoved='1';
    var yl=document.querySelector('.pgu-yml');
    if(yl&&yl.parentElement===main.parentElement)main.parentElement.insertBefore(q,yl);
    else main.parentElement.insertBefore(q,main.nextSibling);
  }
  function cardAtc(){
    /* the button rides at the card's end, under the title and price; its
       LOOK is pg-home's (styleAtc there stamps the product tiles' button
       inline). This used to restamp the old 13.5px pill here under the same
       data-pgStyled flag, and because this script runs before DOMContentLoaded
       it won the race every time: the home page never showed pg-home's
       button (2026-09-11). */
    document.querySelectorAll('#pgh .pgh-card').forEach(function(card){
      var b = card.querySelector('.pgh-atc');
      if (!b) return;
      if (!b.dataset.pgMoved){ b.dataset.pgMoved = '1'; card.appendChild(b); }
    });
  }
  function titleStars(){
    var h2 = document.querySelector('#pgh .pgh-wrap .pgh-h2');
    if (!h2 || h2.dataset.pgTw) return;
    h2.dataset.pgTw = '1';
    var sp = document.createElement('span');
    sp.className = 'pgh-tw';
    while (h2.firstChild) sp.appendChild(h2.firstChild);
    h2.appendChild(sp);
    var cols = ['#B478E0', '#C9A6E8', '#9B4BC4'];
    var P = [['left', -66, -6, 15, 0], ['left', -38, 26, 10, .8], ['left', -96, 16, 12, 1.6], ['left', -50, -28, 9, 2.3], ['right', -66, -6, 15, .4], ['right', -38, 26, 10, 1.2], ['right', -96, 16, 12, 2.0], ['right', -50, -28, 9, 2.7]];
    P.forEach(function(p, i){
      var st = document.createElement('i');
      st.style.cssText = p[0] + ':' + p[1] + 'px;top:' + p[2] + 'px;width:' + p[3] + 'px;height:' + p[3] + 'px;background:' + cols[i % 3] + ';animation-delay:' + p[4] + 's';
      sp.appendChild(st);
    });
  }
  function tilePaint(){
    var bss = document.querySelectorAll('#pgx .pgx-bs');
    for (var bi = 1; bi < bss.length; bi++) bss[bi].remove();
    document.querySelectorAll('#pgx .pgx-storage-lb').forEach(function(l){ l.remove(); });
    document.querySelectorAll('#pgx .pgx-tile').forEach(function(t){
      var key = t.classList.contains('pgx-sel') ? 's' : 'u';
      if (t.dataset.pgTp === key) return;
      t.dataset.pgTp = key;
      t.style.setProperty('background', key === 's' ? '#1C1428' : '#16101F', 'important');
      t.style.setProperty('border-color', key === 's' ? '#8B44BE' : 'rgba(255,255,255,.14)', 'important');
      t.querySelectorAll('*').forEach(function(el){
        /* The add-on row and the pg-drop pickers own their styling. Stamping
           them here is what made every bundle selection flicker: this wrote
           58px on picker thumbnails and pg-pick-size wrote 30px right back
           (231 IMG style mutations measured across three tile clicks), and it
           blew the add-on row's 24px thumb up to 58px and its purple price to
           white. */
        /* the tier note owns its colours too: this stamp wrote color:#fff
           !important onto its <b>s and flattened the lavender highlights */
        if (el.closest && (el.closest('.pg-tadd') || el.closest('.pg-drop') || el.closest('.pgx-tier-note'))) return;
        if (el.tagName === 'IMG'){
          el.style.setProperty('object-fit', 'cover', 'important');
          el.style.setProperty('aspect-ratio', '1/1', 'important');
          el.style.setProperty('width', el.closest('.pgx-trio') ? '56px' : (el.closest('.pgx-solo-body') ? '80px' : (el.closest('.pgx-duo-u') ? '86px' : '58px')), 'important');
          el.style.setProperty('height', 'auto', 'important');
          el.style.setProperty('border-radius', '10px', 'important');
          return;
        }
        if (el.tagName === 'OPTION') return;
        if (el.tagName === 'SELECT'){
          if (el.closest('.pgx-lad-selw')){
            el.style.setProperty('border', 'none', 'important');
            el.style.setProperty('background-color', 'transparent', 'important');
            el.style.setProperty('color', '#fff', 'important');
            el.style.setProperty('height', '28px', 'important');
            el.style.setProperty('font-size', '12.5px', 'important');
            return;
          }
          if (!el.dataset.pgGb){
            el.dataset.pgGb = '1';
            Array.prototype.slice.call(el.options).forEach(function(o){
              if (o.textContent.indexOf('/') > -1) o.textContent = o.textContent.split('/').pop().replace(/^\s+|\s+$/g, '');
            });
          }
          ['background-color:#16101F','color:#fff','border:1.5px solid rgba(139,68,190,.75)','height:30px','min-height:0','padding:2px 26px 2px 10px','font-size:12.5px','border-radius:8px','width:auto','max-width:140px','line-height:1.2','appearance:none','-webkit-appearance:none','background-repeat:no-repeat','background-position:right 8px center'].forEach(function(kv){
            var i3 = kv.indexOf(':');
            el.style.setProperty(kv.slice(0, i3), kv.slice(i3 + 1), 'important');
          });
          /* THE SINGLE TILE'S PICKER IS ALONE IN ITS ROW and carries the
             "(Best Value)" suffix pg-landing's labelBest() writes: at 12.5px
             that option needs 147px, and the 140px cap above (meant for the
             pack pickers, which sit two and three to a row) clipped it to
             "128GB (Best Va" the moment 128GB was chosen (by report,
             2026-09-11 evening). The row has about 263px at 375px, so this
             one picker may run to 220px. */
          if (el.getAttribute('data-pgx-size') === 's1'){
            el.style.setProperty('max-width', '220px', 'important');
          }
          /* INSIDE A PACK UNIT THE SELECT IS THE COLUMN'S WIDTH, NEVER WIDER.
             Its intrinsic width comes from its longest option, and a wide
             option is what pushed three columns to 458px inside a 291px body
             at 375px. Filling the column and forbidding overflow makes the
             grid's minmax(0,1fr) actually able to shrink. */
          if (el.closest('.pgx-duo-u')){
            el.style.setProperty('width', '100%', 'important');
            el.style.setProperty('max-width', '100%', 'important');
            el.style.setProperty('box-sizing', 'border-box', 'important');
            el.style.setProperty('min-width', '0', 'important');
            if (el.closest('.pgx-trio')){
              el.style.setProperty('padding', '2px 18px 2px 6px', 'important');
              el.style.setProperty('font-size', '11.5px', 'important');
            }
          }
          el.style.setProperty('background-image', 'url("data:image/svg+xml;utf8,<svg xmlns=%22http://www.w3.org/2000/svg%22 width=%2210%22 height=%226%22 viewBox=%220 0 10 6%22><path d=%22M1 1l4 4 4-4%22 stroke=%22%23C79BEA%22 stroke-width=%221.8%22 fill=%22none%22 stroke-linecap=%22round%22/></svg>")', 'important');
          return;
        }
        var mut = el.tagName === 'S' || /pgx-sstrike|old-price/.test(el.className || '');
        /* the per-unit line under the struck price keeps its light purple
           (the stylesheet's #C79BEA): this stamp painted it white */
        if (/(^|\s)pgx-each(\s|$)/.test(el.className || '')) return;
        el.style.setProperty('color', mut ? 'rgba(255,255,255,.85)' : '#fff', 'important');
      });
    });
  }
  function accPaint(){
    document.querySelectorAll('#pgx .pgx-acc details[open]').forEach(function(d){
      if (!d.dataset.pgClosed){ d.dataset.pgClosed = '1'; d.removeAttribute('open'); }
    });
    document.querySelectorAll('#pgx .pgx-acc details').forEach(function(d){
      if (d.dataset.pgAp) return;
      d.dataset.pgAp = '1';
      d.style.setProperty('border', '1.5px solid rgba(139,68,190,.5)', 'important');
      d.style.setProperty('border-radius', '14px', 'important');
      d.style.setProperty('margin-bottom', '12px', 'important');
      d.style.setProperty('padding', '0 18px', 'important');
      d.style.setProperty('background', '#16101F', 'important');
    });
  }
  function bsFix(){
    var bs = document.querySelector('#pgx .pgx-bs');
    if (!bs) return;
    var tiles = Array.prototype.slice.call(document.querySelectorAll('#pgx .pgx-tile')).filter(function(t){
      return getComputedStyle(t).display !== 'none';
    });
    if (!tiles.length) return;
    var target = tiles[0];
    if (bs.nextElementSibling !== target && target.parentElement) target.parentElement.insertBefore(bs, target);
  }
  /* labelPacks lives in the pgDuo closure below and is exported as
     window.pgLabelPacks; the bare call this line used to make threw a
     ReferenceError on every beat. */
  function tick(){ put(); subWhite(); paint(); paintNews(); killUsdc(); moveQuote(); cardAtc(); titleStars(); tilePaint(); accPaint(); bsFix(); if (window.pgLabelPacks) window.pgLabelPacks(); }
  /* The selected tile's purple border is stamped INLINE by tilePaint, which
     used to run only on the 1600ms interval - so a click showed its highlight
     up to 1.6s late (the stale inline border-color outranked the .pgx-sel
     CSS). Repaint on the click itself, after the handlers have flipped the
     classes. */
  document.addEventListener('click', function(e){
    if (e.target && e.target.closest && e.target.closest('#pgx .pgx-tile')){
      /* setTimeout, not rAF: it must land after the click handlers flip the
         classes, and it must still fire when the tab is hidden */
      setTimeout(tilePaint, 0);
      setTimeout(tilePaint, 60);
    }
  }, true);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', tick); else tick();
  setTimeout(tick, 900); setInterval(tick, 1600);
})();
;
/* pg-theme-css */
(function(){
  if (window.pgDuo) return; window.pgDuo = 1;
  var VARS = null, BUSY = false;
  function money(n){ return '$' + n.toFixed(2); }
  /* THE PACK'S OWN PRICE, NEVER A DERIVED ONE.

     This used to compute the duo total as first console + second console minus
     25% of the left one, mirroring the "R36S - 2nd Console 25% Off" BXGY. That
     discount was RETIRED on 2026-09-10 and each pack now carries its own tier
     price, so the derivation went stale the moment the singles were repriced:
     the tile advertised $131.23 for a pack the till charged $135.98. Showing a
     price checkout will not honor is the one thing this store must never do,
     so the figure is read from the pack product itself and the tile and the
     till cannot disagree again.

     Keyed on the SORTED pair, so 64+128 and 128+64 resolve to one entry. The
     duo carried a duplicate 128GB+64GB variant priced $2.50 apart from its
     twin; sorting means a mixed pack can only ever find the survivor. */
  var PACK = null;
  function sizeOf(v){ return /128/.test(v.t) ? '128' : '64'; }
  function packKey(){
    return Array.prototype.slice.call(arguments).sort().join('|');
  }
  function loadPack(j, handle){
    var dp = (j.products || []).filter(function(x){ return x.handle === handle; })[0];
    if (!dp) return null;
    var out = {};
    (dp.variants || []).forEach(function(v){
      var sizes = String(v.title).match(/\d+(?=GB)/g);
      if (!sizes || !sizes.length) return;
      /* FIRST MATCH WINS. The duo's retired 128GB+64GB duplicate sits after
         the surviving 64GB+128GB in variant order and keys identically once
         sorted; an unguarded write let the retired id overwrite the survivor. */
      if (out[packKey.apply(null, sizes)]) return;
      out[packKey.apply(null, sizes)] = {
        p: parseFloat(v.price || 0),
        c: parseFloat(v.compare_at_price || 0),
        id: v.id
      };
    });
    return out;
  }
  /* EVERY TILE CARRIES A LABEL ("each bundle needs something", by request
     2026-09-11), ranked from the prices: the tile whose saving against its
     compare-at is the deepest (whole percents, as the SAVE pill prints; the
     single's read from its pill, the packs' from their live recalculation)
     is "Best Deal", the next "Great Value", the next "Good Value"; a tile
     tied with one above it takes the next name down. MOST POPULAR comes
     from the orders, which the browser cannot see, so it is a section
     setting (Customize > footer > PG Theme CSS), set to the single console
     on 2026-09-11 (14 orders held one console, 11 of them the 128G; 3 held
     two; none three) and moved by hand as sales move. It replaces that
     tile's ranking name, except "Best Deal", which is a price fact and
     stays. ONLY THE BEST DEAL IS SHOWN, and it rides INSIDE that tile's
     SAVE pill, side by side with the percent ("BEST DEAL · SAVE 43%"), the
     way the orb's biggest pack wears its own (pg-tile-copy): by request,
     2026-09-11, "copy how the orb has it, side by side", after one pass
     that stacked a second ribbon pill under SAVE and another that labelled
     every tile ("looks repetitive"). The other tiles wear a plain "SAVE N%".
     The ranking below still names Great Value / Good Value / Most Popular,
     but only Best Deal is painted; the .pgx-duo-ribbon in the pack markup is
     kept but left empty (the :empty rule hides it), so nothing stacks. */
  /* THE DUO IS MOST POPULAR AND WEARS IT IN ITS PILL, "MOST POPULAR . SAVE
     32%", the way the lamp page's Duo Pack does (by request, 2026-09-11
     night: "copy how the goku lamp one has most popular tag on second
     bundle"). Fixed to the duo here rather than read from the retired
     section setting, whose saved value pointed at the single. */
  var MOST_POPULAR = 'duo';
  var RANK_NAMES = ['Best Deal', 'Great Value', 'Good Value'];
  window.pgLabelPacks = labelPacks;
  function labelPacks(){
    var onR36 = location.pathname.indexOf('/products/handheld-game-console') !== -1;
    var packs = Array.prototype.slice.call(document.querySelectorAll('#pgx .pgx-tile.pgx-duo'));
    var single = onR36 ? document.querySelector('#pgx .pgx-tile[data-pgx-tile="single"]') : null;
    if (!packs.length && !single) return;
    var tiles = (single ? [single] : []).concat(packs);
    function pctOf(t){
      if (t === single){
        var b = t.querySelector('.pgx-lad-badge'), m = b && /(\d+)\s*%/.exec(b.textContent || '');
        return m ? parseInt(m[1], 10) : 0;
      }
      return Math.floor(parseFloat(t.dataset.pgPct || '0') * 100);
    }
    var ranked = tiles.map(function(t){ return {t: t, pc: pctOf(t)}; }).sort(function(a, b){ return b.pc - a.pc; });
    var nameIx = 0;
    ranked.forEach(function(e, i){
      if (i > 0) nameIx = (e.pc === ranked[i - 1].pc) ? nameIx + 1 : i;
      e.txt = e.pc > 0 ? (RANK_NAMES[Math.min(nameIx, RANK_NAMES.length - 1)] || '') : '';
    });
    var mp = null;
    if (MOST_POPULAR === 'single') mp = single;
    else if (MOST_POPULAR === 'duo') mp = packs.filter(function(t){ return !t.classList.contains('pgx-trio'); })[0] || null;
    else if (MOST_POPULAR === 'trio') mp = packs.filter(function(t){ return t.classList.contains('pgx-trio'); })[0] || null;
    ranked.forEach(function(e){ if (mp && e.t === mp && e.txt !== 'Best Deal') e.txt = 'Most Popular'; });
    /* THE PILL IS SPLIT IN TWO so no script fights another over it: a label
       span in front, and behind it the percent span, which carries the
       data-pg-duosave / data-pg-singlesave attribute every percent writer
       looks up (calc() above, the storage picker in build(), pg-case-mobile's
       strikeSync on its 250ms beat). Those keep writing a plain "SAVE N%"
       into the percent span alone, so the label survives every repricing.
       The first pass moves the attribute off the pill onto the new span and
       carries the pill's current text with it; every later pass only writes
       a label that differs, so the 2.5s beat is silent when nothing changed.
       Only the Best Deal tile gets a label; every other tile's label span
       stays empty, so its pill reads a plain "SAVE N%" like the orb's other
       rungs. The label is uppercased in the text itself (pg-save-badge
       uppercases the pill visually anyway) so anything that reads the pill's
       text, such as pg-tile-copy's bottom bar, gets the orb's exact
       "BEST DEAL · SAVE 43%". The ribbon is always left empty. */
    ranked.forEach(function(e){
      var pill = e.t.querySelector('.pgx-lad-badge');
      if (pill){
        var lbl = pill.querySelector('.pgx-pill-lbl');
        if (!lbl){
          var attr = pill.hasAttribute('data-pg-duosave') ? 'data-pg-duosave' : 'data-pg-singlesave';
          var pct = pill.querySelector('[' + attr + ']');
          if (!pct){
            var had = pill.textContent || '';
            pill.removeAttribute(attr);
            pill.textContent = '';
            pct = document.createElement('span');
            pct.setAttribute(attr, '1');
            pct.textContent = had;
            pill.appendChild(pct);
          }
          lbl = document.createElement('span');
          lbl.className = 'pgx-pill-lbl';
          pill.insertBefore(lbl, pill.firstChild);
        }
        var want = e.txt === 'Best Deal' ? 'BEST DEAL \u00B7 ' : (e.txt === 'Most Popular' ? 'MOST POPULAR \u00B7 ' : '');
        if (lbl.textContent !== want) lbl.textContent = want;
      }
      put(e.t, '');
    });
    function put(t, txt){
      var r = t.querySelector('.pgx-duo-ribbon');
      if (!r && !txt) return;
      if (!r){ r = document.createElement('span'); r.className = 'pgx-duo-ribbon'; t.insertBefore(r, t.firstChild); }
      if (r.textContent !== txt) r.textContent = txt;
      /* the price block clears the stacked pair (SAVE straddles the top
         border, the label sits under it): 34px when labelled, else none */
      var px = t.querySelector('.pgx-duo-px, .pgx-tile-price');
      if (px){
        var want = txt ? '34px' : '';
        if (px.dataset.pgDrop !== want){
          px.dataset.pgDrop = want;
          if (want) px.style.setProperty('margin-top', want, 'important'); else px.style.removeProperty('margin-top');
        }
      }
    }
  }
  function calc(tile){
    if (!VARS) return;
    /* one picker per console: two on the duo, three on the trio */
    var sels = tile.querySelectorAll('select');
    var vs = Array.prototype.map.call(sels, function(s){ return VARS.filter(function(v){ return String(v.id) === s.value; })[0]; });
    if (vs.length < 2 || vs.some(function(v){ return !v; })) return;
    var pack = PACK ? PACK[packKey.apply(null, vs.map(sizeOf))] : null;
    var sep = vs.reduce(function(a, v){ return a + v.p; }, 0);      /* the singles at today's live prices */
    var total = pack ? pack.p : sep;
    var orig = (pack && pack.c) ? pack.c : vs.reduce(function(a, v){ return a + (v.c || v.p); }, 0);
    /* NO SURCHARGE ON THE 128GB OPTION. A "+$13.00 each" hint was tried on
       the picker and pulled the same day: it foregrounds the upgrade as a cost
       rather than as storage, and the longer option text widened every
       <select> to 140px, which pushed both pack bodies past the tile edge at
       375px. The tile total repricing the instant a size changes is the
       signal, and it needs no copy. */
    tile.querySelector('.pgx-duo-px b').textContent = money(total);
    tile.querySelector('.pgx-duo-px s').textContent = money(orig);
    /* the per-console figure in the pill under the struck price: the pack
       total over its consoles, in whole cents (prices here are dollars, so
       the total is put back into cents before dividing; a float divide
       printed $63.00 for 125.98 / 2), rounded UP so n x the printed figure
       never undercuts the total (every pack today divides exactly: 62.99,
       69.49, 75.99; 56.99, 60.99, 64.99, 68.99); it follows the GB picks
       with the total */
    var eachPill = tile.querySelector('.pgx-each');
    if (eachPill){ var eachTxt = money(Math.ceil(Math.round(total * 100) / vs.length) / 100) + ' each'; if (eachPill.textContent !== eachTxt) eachPill.textContent = eachTxt; }
    var dsv = tile.querySelector('[data-pg-duosave]');
    /* FLOOR, NEVER ROUND. Rounding a 32.5% saving up to 33% advertises a
       discount the shopper does not receive. Flooring means the delivered
       percentage always meets or beats the badge, on every configuration. */
    if (dsv && orig > total) dsv.textContent = 'SAVE ' + Math.floor((orig - total) / orig * 100) + '%';
    tile.dataset.pgPct = orig > total ? String((orig - total) / orig) : '0';
    labelPacks();
    /* ONE PRICE PER TILE. The per-unit figures went out with the BXGY: there is
       no longer a discounted console and a full-price one, only a pack price,
       so printing a struck price under each unit invented a split that does not
       exist and did not add up to the total above it. Each unit keeps its
       picker and nothing else. */
    Array.prototype.forEach.call(tile.querySelectorAll('.pgx-duo-u .pp'), function(pp){ pp.innerHTML = ''; });
    /* ONE REFERENCE PRICE PER TILE. This line used to read "Sold separately
       $149.98" (the singles' live prices) beside a badge computed against the
       $199.98 compare-at total: two references, and a shopper doing the maths
       on the first one got 9%, not the 32% on the badge. The struck total is
       the one reference now (it is the sum of the $99.99 / $119.99 each single
       shows struck), so the sub-line carries no second number. */
    tile.querySelector('.pgx-duo-t small').textContent = (vs.length === 3 ? 'Three consoles, one price' : 'Two consoles, one price');
  }
  function build(){
    var m = location.pathname.match(/\/products\/([^\/?#]+)/);
    if (!m) return;
    var isR36 = m[1] === 'handheld-game-console';
    var first = document.querySelector('#pgx .pgx-tile');
    if (!first || !first.parentElement) return;
    if (first.dataset.pgSingled && (!isR36 || document.querySelector('.pgx-duo'))){
      /* built already: keep the tile labels honest on this beat. Idempotent
         (labelPacks only writes what differs). */
      if (isR36) labelPacks();
      return;
    }
    window.pgCatalog().then(function(j){
      var p = (j.products || []).filter(function(x){ return x.handle === m[1]; })[0];
      if (!p) return;
      var duoMap = loadPack(j, 'r36s-duo-pack') || {}, trioMap = loadPack(j, 'r36s-trio-pack') || {};
      PACK = {};
      Object.keys(duoMap).forEach(function(k){ PACK[k] = duoMap[k]; });
      Object.keys(trioMap).forEach(function(k){ PACK[k] = trioMap[k]; });
      var img = (p.images && p.images[0] && p.images[0].src) || '';
      VARS = (p.variants || []).map(function(v){ return {id: v.id, t: (v.title.indexOf('/') > -1 ? v.title.split('/').pop() : v.title).replace(/^\s+|\s+$/g, ''), p: parseFloat(v.price || 0), c: parseFloat(v.compare_at_price || 0)}; });
      if (VARS.length < 1) return;
      /* Default both Duo Pack slots to the 64G variant. Without an explicit
         selection the browser takes the first option, which is the 128G one,
         so the pack opened at the dearer configuration. */
      var duoDef = VARS.filter(function(v){ return /(^|\D)64/.test(v.t); })[0] || VARS[0];
      var opts = VARS.map(function(v){ return '<option value="' + v.id + '"' + (v.id === duoDef.id ? ' selected' : '') + '>' + v.t + '</option>'; }).join('');
      /* BOTH SLOTS ARE FREE AGAIN. The lock existed only because Shopify's
         BXGY decided which unit got the 25% and always picked the cheaper one.
         The pack is its own product now, priced per configuration, so nothing
         is decided at checkout and any pairing can be offered honestly. */
      if (isR36 && !document.querySelector('.pgx-duo')){
      var tile = document.createElement('div');
      tile.className = 'pgx-tile pgx-duo';
      tile.setAttribute('data-pgx-duo', '1');
      tile.setAttribute('role', 'radio');
      tile.setAttribute('aria-checked', 'false');
      tile.setAttribute('tabindex', '0');
      /* one label per pack, opposite the SAVE pill, by request (2026-09-11);
         labelPacks() below fills them from the live SAVE % */
      tile.innerHTML = '<span class="pgx-lad-badge" data-pg-duosave></span><span class="pgx-duo-ribbon"></span>'
        + '<div class="pgx-duo-head"><span class="pgx-duo-dot"></span>'
        + '<div class="pgx-duo-t"><b>Duo Pack <span class="pgx-lad-chip">+ FREE Case</span></b><small></small></div>'
        + '<div class="pgx-duo-px"><b></b><s></s><span class="pgx-lad-chip pgx-each"></span></div></div>'
        + '<div class="pgx-duo-body" style="border:1px solid rgba(139,68,190,.5);border-radius:12px"><span class="pgx-duo-plus">+</span>'
        + '<div class="pgx-duo-u" style="border-right:1px solid rgba(139,68,190,.45)"><img src="' + img + '" alt=""><div class="n">R36S</div><div class="pp"></div><select aria-label="Version 1">' + opts + '</select></div>'
        + '<div class="pgx-duo-u"><img src="' + img + '" alt=""><div class="n">R36S</div><div class="pp"></div><select aria-label="Version 2">' + opts + '</select></div></div>';
      first.parentElement.insertBefore(tile, first.nextSibling);
      calc(tile);
      }
      /* THE TRIO PACK: the duo's parts with a third slot. It wears .pgx-duo as
         well as .pgx-trio so every rule that already keys on the duo -- the
         collapsed body when unselected, the ribbon, the one pack-owning add
         handler in pg-r36s-mobile -- applies unchanged; .pgx-trio carries only
         the differences (three columns, two joiners, two spares). */
      if (isR36 && !document.querySelector('.pgx-trio')){
      var after = document.querySelector('#pgx .pgx-tile.pgx-duo') || first;
      var trio = document.createElement('div');
      trio.className = 'pgx-tile pgx-duo pgx-trio';
      trio.setAttribute('data-pgx-trio', '1');
      trio.setAttribute('role', 'radio');
      trio.setAttribute('aria-checked', 'false');
      trio.setAttribute('tabindex', '0');
      var unit = function(n){ return '<div class="pgx-duo-u"><img src="' + img + '" alt=""><div class="n">R36S</div><div class="pp"></div><select aria-label="Version ' + n + '">' + opts + '</select></div>'; };
      trio.innerHTML = '<span class="pgx-lad-badge" data-pg-duosave></span><span class="pgx-duo-ribbon"></span>'
        + '<div class="pgx-duo-head"><span class="pgx-duo-dot"></span>'
        + '<div class="pgx-duo-t"><b>Trio Pack <span class="pgx-lad-chip">+ FREE Case</span></b><small></small></div>'
        + '<div class="pgx-duo-px"><b></b><s></s><span class="pgx-lad-chip pgx-each"></span></div></div>'
        + '<div class="pgx-duo-body" style="border:1px solid rgba(139,68,190,.5);border-radius:12px"><span class="pgx-duo-plus p1">+</span><span class="pgx-duo-plus p2">+</span>'
        + unit(1) + unit(2) + unit(3) + '</div>';
      after.parentElement.insertBefore(trio, after.nextSibling);
      calc(trio);
      }
      /* the tier notes, one per tile; the bottom deal note is retired on this page */
      if (isR36){
        var noteFor = function(t, html){
          if (!t || t.querySelector('.pgx-tier-note')) return;
          var n = document.createElement('div');
          n.className = 'pgx-tier-note';
          n.innerHTML = html;
          /* under the pickers, ahead of the spare-case add-on row pgTileAdd appends later */
          var body = t.querySelector('.pgx-duo-body'), tadd = t.querySelector('.pg-tadd');
          if (body && body.parentNode === t) t.insertBefore(n, body.nextSibling);
          else if (tadd && tadd.parentNode === t) t.insertBefore(n, tadd);   /* the single: above its add-on row too */
          else t.appendChild(n);
        };
        noteFor(first, '<b>One R36S + FREE Case</b>, plus an extra <b>5% off</b> at checkout.');
        noteFor(document.querySelector('#pgx .pgx-tile.pgx-duo:not(.pgx-trio)'), '<b>Duo Pack + FREE Case</b>, plus an extra <b>5% off</b> at checkout.');
        noteFor(document.querySelector('#pgx .pgx-tile.pgx-trio'), '<b>Trio Pack + FREE Case</b>, plus an extra <b>5% off</b> at checkout.');
        var pgx = document.getElementById('pgx');
        if (pgx) pgx.setAttribute('data-pg-tiernotes', '1');
      }
      if (!document.querySelector('.pgx-bs')){
        var bs = document.createElement('div');
        bs.className = 'pgx-bs';
        bs.innerHTML = '<span>Bundle &amp; Save</span>';
        first.parentElement.insertBefore(bs, first);
      }
      if (!first.dataset.pgSingled){
        first.dataset.pgSingled = '1';
        var od = first.querySelector('.pgx-duo-dot');
        if (od) od.remove();
        if (isR36){
          var nm = first.querySelector('.pgx-tile-name') || first.querySelector('.pgx-tile-row b, .pgx-tile-row h3');
          /* "SINGLE R36S", NOT THE FULL PRODUCT TITLE (by request, 2026-09-11
             night: "rename it to like single R36", the way the lamp page's
             first tile says "Single Lamp"). Short enough to sit beside the
             radio like the pack tiles, which is why pg-tile-copy's nameFit
             no longer lifts it out of the row. Only the text node changes;
             the chip that may already sit inside is left alone. */
          if (nm){
            var tn = null;
            for (var q = 0; q < nm.childNodes.length; q++){
              if (nm.childNodes[q].nodeType === 3 && nm.childNodes[q].textContent.replace(/\s+/g, '')){ tn = nm.childNodes[q]; break; }
            }
            if (tn && tn.textContent.trim() !== 'Single R36S') tn.textContent = 'Single R36S';
          }
          if (nm && !nm.querySelector('.pgx-lad-chip')) nm.insertAdjacentHTML('beforeend', ' <span class="pgx-lad-chip">+ FREE Case</span>');
          /* THE UNIT BOX, like the Duo's and the Trio's: photo, "R36S", the
             size picker. The tile's own <select data-pgx-size="s1"> is MOVED
             in, not copied, so pg-landing's change handler, its labelBest()
             and pg-tile-copy's sticky bar (both find it by attribute or by
             tile, never by its old wrapper) keep working. The emptied
             .pgx-tile-opts row is removed. noteFor() below then seats the
             tier note right after this box, ahead of the Add to cart button
             pg-r36s-mobile appends, the same order the pack tiles have
             ("move the white and purple text above add to cart like duo and
             trio", by request). */
          if (!first.querySelector('.pgx-solo-body')){
            var s1 = first.querySelector('select[data-pgx-size="s1"]');
            var row0 = first.querySelector('.pgx-tile-row');
            if (s1 && row0 && row0.parentNode === first){
              var sb = document.createElement('div');
              sb.className = 'pgx-duo-body pgx-solo-body';
              sb.style.cssText = 'border:1px solid rgba(139,68,190,.5);border-radius:12px';
              sb.innerHTML = '<div class="pgx-duo-u"><img src="' + img + '" alt=""><div class="pgx-solo-t"><div class="n">R36S</div><div class="pp"></div></div></div>';
              sb.querySelector('.pgx-solo-t').appendChild(s1);
              first.insertBefore(sb, row0.nextSibling);
              var opts0 = first.querySelector('.pgx-tile-opts');
              if (opts0 && !opts0.querySelector('select') && opts0.parentNode) opts0.parentNode.removeChild(opts0);
              /* the select fills its unit like the packs' do; the stamp that
                 does this for them only runs when the tile's selection flips */
              ['width:100%', 'max-width:100%', 'box-sizing:border-box', 'min-width:0'].forEach(function(kv){
                var i4 = kv.indexOf(':'); s1.style.setProperty(kv.slice(0, i4), kv.slice(i4 + 1), 'important');
              });
              /* noteFor() above ran before this box existed and seated the
                 tier note ahead of the add-on row, under the Add to cart
                 button; it belongs right after the box, above the button,
                 as on the pack tiles */
              var nt0 = first.querySelector('.pgx-tier-note');
              if (nt0 && nt0.previousElementSibling !== sb) first.insertBefore(nt0, sb.nextSibling);
            }
          }
          if (!first.querySelector('.pgx-lad-badge') && VARS[0] && VARS[0].c > VARS[0].p){
            var sb2 = document.createElement('span');
            sb2.className = 'pgx-lad-badge';
            sb2.setAttribute('data-pg-singlesave', '1');
            sb2.textContent = 'SAVE ' + Math.floor((VARS[0].c - VARS[0].p) / VARS[0].c * 100) + '%';
            first.appendChild(sb2);
          }
        }
        var priceBox = first.querySelector('.pgx-tile-price');
        if (priceBox && !priceBox.querySelector('.pgx-sstrike') && VARS[0] && VARS[0].c > VARS[0].p){
          var ss = document.createElement('s');
          ss.className = 'pgx-sstrike';
          ss.textContent = money(VARS[0].c);
          priceBox.appendChild(ss);
        }
        var haveSel = first.querySelector('.pgx-tile-opts select');
        var pills = haveSel ? [] : Array.prototype.slice.call(first.querySelectorAll('.pgx-tile-opts button, .pgx-tile-opts [role="button"], .pgx-tile-opts span'));
        if (pills.length > 1 && !first.querySelector('.pgx-storage')){
          var lb = document.createElement('div');
          lb.className = 'pgx-storage-lb';
          lb.textContent = 'Storage';
          var sl = document.createElement('select');
          sl.className = 'pgx-storage';
          sl.setAttribute('aria-label', 'Storage');
          pills.forEach(function(pl, i){
            var o = document.createElement('option');
            o.value = String(i);
            o.textContent = pl.textContent.replace(/^\s+|\s+$/g, '');
            sl.appendChild(o);
          });
          sl.addEventListener('click', function(e){ e.stopPropagation(); });
          sl.addEventListener('change', function(){
            var pl = pills[parseInt(sl.value, 10)];
            if (pl) pl.click();
            var vv = VARS.filter(function(v){ return v.t === sl.options[sl.selectedIndex].textContent; })[0];
            var st2 = first.querySelector('.pgx-sstrike');
            if (vv && st2 && vv.c > vv.p) st2.textContent = money(vv.c);
            var bd2 = first.querySelector('[data-pg-singlesave]');
            if (bd2 && vv && vv.c > vv.p) bd2.textContent = 'SAVE ' + Math.floor((vv.c - vv.p) / vv.c * 100) + '%';
          });
          var opts2 = first.querySelector('.pgx-tile-opts');
          opts2.parentElement.insertBefore(lb, opts2);
          opts2.parentElement.insertBefore(sl, opts2);
        }
      }
      /* The single's SAVE pill is only created just above, AFTER both packs
         ran calc() and ranked the tiles without it. Rank once more now, so
         the single's label is in its pill on the first paint. */
      if (isR36) labelPacks();
      /* ONE WIRING FOR EVERY PACK TILE. The duo and the trio get the same
         three bindings: storage pickers recalculate their own tile, a tap
         selects the tile, and a tap on any other tile deselects it. */
      var wire = function(t){
        t.querySelectorAll('select').forEach(function(sel){
          sel.addEventListener('click', function(e){ e.stopPropagation(); });
          /* THE SLOTS ARE INDEPENDENT. An earlier build copied the changed
             select's value onto the others, so a mixed pack could not be
             built at all; calc() reads every picker on its own. */
          sel.addEventListener('change', function(){ calc(t); });
        });
        t.addEventListener('click', function(){
          document.querySelectorAll('#pgx .pgx-tile.pgx-sel').forEach(function(x){ x.classList.remove('pgx-sel'); x.setAttribute('aria-checked', 'false'); });
          t.classList.add('pgx-sel');
          t.setAttribute('aria-checked', 'true');
        });
        document.addEventListener('click', function(e){
          var other = e.target.closest('#pgx .pgx-tile');
          if (other && other !== t && t.classList.contains('pgx-sel')){
            t.classList.remove('pgx-sel');
            t.setAttribute('aria-checked', 'false');
          }
        }, true);
      };
      if (typeof tile !== 'undefined' && tile) wire(tile);
      if (typeof trio !== 'undefined' && trio) wire(trio);
      /* NO ADD-TO-CART HANDLER HERE, ON PURPOSE. This section used to post the
         two CONSOLE variants the pickers held -- one line at quantity 2, or two
         lines at 1 -- which bills $149.98 for a pack the tile prices at
         $135.98. It only ever stayed silent because pg-r36s-mobile takes the
         click first in the window capture phase and posts the ONE pack line
         that matches the tile; if that handler ever failed to run, this one
         would have charged the shopper a price the page never showed. A dead
         button is the safer failure, so there is one owner and it lives in
         pg-r36s-mobile. */
    }).catch(function(){});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', build); else build();
  setTimeout(build, 1000); setInterval(function(){ build(); }, 2500);
})();
;
/* pg-theme-css */
(function(){
  if (window.pgLadder) return; window.pgLadder = 1;
  var BUSY = false;
  function money(n){ return '$' + n.toFixed(2); }
  function build(){
    var m = location.pathname.match(/\/products\/([^\/?#]+)/);
    /* Ladder on every product except the console (its own Duo Pack) and the
       cart-only add-ons. New products get it automatically - but each one
       needs matching BXGY discounts or the page promises a price checkout
       will not honour. */
    /* the packs are sold from the console page; their own pages redirect there
       (product.redirect-console) and must never grow this ladder, whose tiers
       mirror discounts the packs do not carry */
    var NO_LADDER = ['handheld-game-console', 'shipping-protection', 'r36s-protective-case-free-gift', 'r36s-duo-pack', 'r36s-trio-pack'];
    if (!m || NO_LADDER.indexOf(m[1]) !== -1) return;
    if (!window.pgDrop) return;
    if (document.querySelector('.pgx-lad')) return;
    var first = document.querySelector('#pgx .pgx-tile:not(.pgx-lad)');
    if (!first || !first.parentElement) return;
    fetch('/products/' + m[1] + '.js').then(function(r){ return r.json(); }).then(function(p){
      if (!p || !p.variants || document.querySelector('.pgx-lad')) return;
      var unit = (p.variants[0].price || 0) / 100;
      var VOPTS = p.variants.filter(function(v){ return v.available !== false; }).map(function(v){
        return {id: v.id, t: v.title, img: (v.featured_image && v.featured_image.src) || (p.images && p.images[0]) || ''};
      });
      if (!unit || !VOPTS.length) return;
      var host = first.parentElement;
      var natives = Array.prototype.slice.call(host.querySelectorAll('.pgx-tile:not(.pgx-lad)'));
      natives.forEach(function(t){ t.style.setProperty('display', 'none', 'important'); });
      /* The free LED base ships with the crystal orb only. On any other product
         — wall art especially — it promised something the order never contains. */
      var SUB1 = m[1].indexOf('pokemon-crystal') !== -1 ? 'Standard price + FREE LED Base' : 'Standard price';
      var TIERS = [
        {n: 1, f: 0, bases: 1, badge: '', title: 'Buy 1', sub: SUB1},
        {n: 1, f: 0, h: 1, hp: 0.25, bases: 2, badge: 'Most Popular &#128293;', title: 'Duo Pack &mdash; 2nd 25% OFF', sub: ''},
        {n: 2, f: 0, h: 1, hp: 0.5, bases: 3, badge: '', title: 'Trio Pack &mdash; 3rd 50% OFF', sub: ''},
        {n: 4, f: 1, bases: 5, badge: 'Best Deal!', title: 'Quad Pack &mdash; +1 FREE', sub: ''}
      ];
      var tiles = [];
      TIERS.forEach(function(T, ti){
        var half = T.h || 0, hp = (T.hp == null ? 0.5 : T.hp);
        var pay = (T.n + half * (1 - hp)) * unit, save = (T.f + half * hp) * unit, full = (T.n + T.f + half) * unit;
        var pct = Math.round(save / full * 100);
        var tile = document.createElement('div');
        tile.className = 'pgx-tile pgx-lad' + (ti === 0 ? ' pgx-sel' : '');
        tile.setAttribute('role', 'radio');
        tile.setAttribute('aria-checked', ti === 0 ? 'true' : 'false');
        tile.setAttribute('tabindex', '0');
        tile.setAttribute('data-pg-tier', String(ti));
        var chips = T.bases > 1 ? '<span class="pgx-lad-chip">+' + T.bases + (m[1].indexOf('pokemon-crystal') !== -1 ? ' FREE LED Bases' : (m[1].indexOf('wall-art') !== -1 ? ' PRINTS' : ' ITEMS')) + '</span>' : '';
        /* R36S-style phrasing: name the unit that gets the deal, e.g.
           "2nd Orb = Extra 25% OFF!" rather than a dollar total. */
        var NOUN = m[1].indexOf('pokemon-crystal') !== -1 ? 'Orb' : (m[1].indexOf('wall-art') !== -1 ? 'Print' : 'Item');
        function ord(k){ return k + (k === 1 ? 'st' : k === 2 ? 'nd' : k === 3 ? 'rd' : 'th'); }
        var note = '';
        if (half > 0) note = ord(T.n + 1) + ' ' + NOUN + ' = Extra ' + Math.round(hp * 100) + '% OFF!';
        else if (T.f > 0) note = ord(T.n + 1) + ' ' + NOUN + ' = FREE!';
        var saveLn = note ? '<div class="pgx-lad-save">' + note + '</div>' : '<div class="pgx-lad-save">' + T.sub + '</div>';
        tile.innerHTML = (T.badge ? '<span class="pgx-lad-badge">' + T.badge + '</span>' : '')
          + '<div class="pgx-lad-head"><span class="pgx-duo-dot"></span>'
          + '<div class="pgx-lad-t"><b>' + T.title + '</b>' + chips + saveLn + '</div>'
          + '<div class="pgx-lad-px"><b>' + money(pay) + '</b>' + ((T.f > 0 || half > 0) ? '<s>' + money(full) + '</s>' : (unit < ((p.variants[0].compare_at_price || 0) / 100) ? '<s>' + money((p.variants[0].compare_at_price) / 100) + '</s>' : '')) + '</div></div>'
          + '<div class="pgx-lad-picks"><div class="lbl">' + (m[1].indexOf('pokemon-crystal') !== -1 ? 'Choose your Poke Balls' : (m[1].indexOf('wall-art') !== -1 ? 'Choose your prints' : 'Choose your options')) + '</div></div>';
        var picks = tile.querySelector('.pgx-lad-picks');
        var total = T.n + T.f + half;
        /* One design to choose from means one picker with a x N badge, not
           N identical dropdowns. */
        var rows = VOPTS.length > 1 ? total : 1;
        tile.dataset.pgMul = String(rows === 1 ? total : 1);
        for (var i = 0; i < rows; i++){
          var row = document.createElement('div');
          row.className = 'pgx-lad-row';
          row.appendChild(window.pgDrop(VOPTS, VOPTS[i % VOPTS.length].id, null));
          if (rows === 1 && total > 1){
            var xb = document.createElement('b');
            xb.textContent = '\u00d7' + total;
            xb.style.cssText = 'margin-left:10px;font-size:15px;font-weight:700;color:#C79BEA;align-self:center';
            row.appendChild(xb);
          }
          picks.appendChild(row);
        }
        host.insertBefore(tile, first);
        tiles.push(tile);
        tile.addEventListener('click', function(){
          tiles.forEach(function(t2){ t2.classList.remove('pgx-sel'); t2.setAttribute('aria-checked', 'false'); t2.dataset.pgTp = ''; });
          tile.classList.add('pgx-sel');
          tile.setAttribute('aria-checked', 'true');
        });
      });
      document.addEventListener('click', function(e){
        var b = e.target.closest('.pgx-atc');
        if (!b || BUSY) return;
        var sel = document.querySelector('.pgx-lad.pgx-sel');
        if (!sel) return;
        e.preventDefault();
        e.stopPropagation();
        BUSY = true;
        var counts = {};
        var mul = parseInt(sel.dataset.pgMul || '1', 10) || 1;
        sel.querySelectorAll('.pgx-lad-picks .pg-drop').forEach(function(d2){
          var vv = d2.pgValue();
          counts[vv] = (counts[vv] || 0) + mul;
        });
        var items = Object.keys(counts).map(function(k){ return {id: parseInt(k, 10), quantity: counts[k]}; });
        fetch('/cart/add.js', {method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify({items: items})})
          .then(function(r){ BUSY = false; if (!r || !r.ok) throw new Error('add ' + (r && r.status)); if (window.pgOpenCart) window.pgOpenCart(); })
          .catch(function(){
            /* a refused add used to open the drawer as if it had worked */
            BUSY = false;
            var err = document.getElementById('pgx-err');
            if (err){ err.textContent = 'Could not add to cart. Please try again.'; err.style.display = 'block'; }
          });
      }, true);
    }).catch(function(){});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', build); else build();
  setTimeout(build, 1200); setInterval(build, 3000);
})();
;
/* pg-theme-css */
(function(){
  if (window.pgTileAdd) return; window.pgTileAdd = 1;

  /* Per-product add-on config. Prices in cents and REAL: unit is what
     checkout charges, cap is the variant's live compareAtPrice - the struck
     figure is cap x qty, never invented at render time. If either price
     moves in admin, move it here too. */
  var ADDONS = {
    'lenticular-poster': {
      cls: 'pg-tadd-frame',
      variant: 49688364613860,
      img: 'https://cdn.shopify.com/s/files/1/0815/5706/1860/files/blackframe_120x.png?v=1787284280',
      unit: 1499, cap: 2799,
      one: 'Add the matching frame',
      many: 'Add a frame per print'
    },
    'handheld-game-console': {
      variant: 49640879063268,
      img: 'https://cdn.shopify.com/s/files/1/0815/5706/1860/files/hf_20260810_234744_eb2ec102-427d-4c23-94f0-453e70014817.png?v=1786422962&width=120',
      unit: 1799, cap: 2499,   /* $17.99 since 2026-09-14 (was $13.99), the free one stays free */
      one: 'Add a spare protective case',
      many: 'Add a spare case for each console'
    }
  };
  function cfg(){
    var m = location.pathname.match(/\/products\/([^\/?#]+)/);
    if (!m) return null;
    for (var k in ADDONS){ if (m[1].indexOf(k) !== -1) return ADDONS[k]; }
    return null;
  }
  var C = cfg();
  if (!C) return;

  function money(c){ return '$' + (c / 100).toFixed(2); }

  /* units the tile sells: the duo tile is fixed at 2; ladder tiles carry one
     picker per unit (times data-pg-mul on single-design products); a bare
     native tile is 1 */
  function unitsOf(tile){
    /* SPARES NEEDED, NOT CONSOLES SOLD. The Duo Pack ships two consoles AND a
       free case, so the shopper needs ONE more case, not two -- this offered
       "a spare case for each console" at $27.98 next to a pack that already
       includes one. One case, $17.99 (since 2026-09-14; $13.99 before). */
    if (tile.classList.contains('pgx-trio')) return 2;   /* three consoles, one free case */
    if (tile.classList.contains('pgx-duo')) return 1;
    var d = tile.querySelectorAll('.pgx-lad-picks .pg-drop').length;
    var mul = parseInt(tile.dataset.pgMul || '1', 10) || 1;
    return d ? d * mul : 1;
  }

  /* one row per tile, appended once and re-priced on every pass - the theme
     rebuilds tiles, so this settles rather than assumes */
  function pass(){
    document.querySelectorAll('#pgx .pgx-tile').forEach(function(tile){
      if (!tile.getClientRects().length) return;   /* natives hidden by pgLadder */
      var row = tile.querySelector('.pg-tadd');
      if (!row){
        row = document.createElement('div');
        row.className = 'pg-tadd' + (C.cls ? ' ' + C.cls : '');
        row.setAttribute('role', 'checkbox');
        row.setAttribute('aria-checked', 'false');
        row.setAttribute('tabindex', '0');
        row.innerHTML = '<span class="pg-tadd-ck" aria-hidden="true"></span>'
          + '<img alt="" src="' + C.img + '">'
          + '<span class="pg-tadd-t"></span>'
          + '<span class="pg-tadd-p"><s></s><b></b></span>';
        tile.appendChild(row);
      }
      /* THE ROW SITS UNDER THE ADD TO CART BUTTON, ALWAYS. This row and
         pg-r36s-mobile's .pg-r36-atc are both appended to the tile by
         whichever script gets there first, so their order was a coin flip
         and on one load the case checkbox sat above the button (measured
         2026-09-11 night on the single tile). Put right, idempotently, on
         every beat. */
      var atcB = tile.querySelector('.pg-r36-atc');
      if (atcB && atcB.parentNode === tile && row.parentNode === tile && (atcB.compareDocumentPosition(row) & 2)){
        tile.insertBefore(row, atcB.nextSibling);
      }
      var n = unitsOf(tile);
      var t = row.querySelector('.pg-tadd-t');
      var txt = n > 1 ? C.many : C.one;
      /* THE DUO TILE SAYS WHY IT IS ONLY ASKING FOR ONE. The pack ships two
         consoles and a free case, so the offer covers the second console only.
         Without saying so the row reads like a mistake next to a two-console
         pack -- one case, one price, no explanation. */
      if (tile.classList.contains('pgx-trio')) txt = 'Add 2 spare protective cases';
      if (tile.classList.contains('pgx-duo')) txt = txt + ' (1 Comes Free)';
      if (t.textContent !== txt) t.textContent = txt;
      var s = row.querySelector('.pg-tadd-p s'), b = row.querySelector('.pg-tadd-p b');
      var sTxt = money(C.cap * n), bTxt = money(C.unit * n);
      if (s.textContent !== sTxt) s.textContent = sTxt;
      if (b.textContent !== bTxt) b.textContent = bTxt;
    });
  }

  /* toggle. Capture phase and stopPropagation: a click on the row must not
     fall through to the tile's own click handler chain twice, and must never
     reach the pickers. Toggling still SELECTS the tile first if it was not,
     so a tap on an unselected tile's row does both things the shopper meant. */
  document.addEventListener('click', function(e){
    var row = e.target && e.target.closest && e.target.closest('#pgx .pg-tadd');
    if (!row) return;
    e.stopPropagation();
    var tile = row.closest('.pgx-tile');
    if (tile && !tile.classList.contains('pgx-sel')) tile.click();
    var on = !row.classList.contains('on');
    row.classList.toggle('on', on);
    row.setAttribute('aria-checked', on ? 'true' : 'false');
  }, true);
  document.addEventListener('keydown', function(e){
    if (e.key !== ' ' && e.key !== 'Enter') return;
    var row = e.target && e.target.closest && e.target.closest('#pgx .pg-tadd');
    if (!row) return;
    e.preventDefault();
    row.click();
  }, true);

  /* ride along with ADD TO CART: the tile handlers (pg-landing, pgLadder,
     the duo tile) post their own items; this posts the add-on shortly after
     and refreshes the drawer so the new line is on screen. */
  var busy = false;
  document.addEventListener('click', function(e){
    var b = e.target && e.target.closest && e.target.closest('.pgx-atc');
    if (!b || busy) return;
    /* the VISIBLE selected tile: on ladder pages the hidden native single
       still wears .pgx-sel from its initial render */
    var sel = Array.prototype.slice.call(document.querySelectorAll('#pgx .pgx-tile.pgx-sel'))
      .filter(function(t){ return t.getClientRects().length; })[0];
    if (!sel) return;
    var row = sel.querySelector('.pg-tadd.on');
    if (!row) return;
    var qty = unitsOf(sel);
    busy = true;
    setTimeout(function(){
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        credentials: 'same-origin',
        body: JSON.stringify({items: [{id: C.variant, quantity: qty}]})
      }).then(function(r){
        busy = false;
        if (!r || !r.ok) throw new Error('addon ' + (r && r.status));
        if (window.pgDrawerRefresh){ try { window.pgDrawerRefresh(); return; } catch(err){} }
        if (window.pgOpenCart) window.pgOpenCart();
      }).catch(function(){
        /* a refused add-on used to refresh the drawer as if it had gone in */
        busy = false;
        var err = document.getElementById('pgx-err');
        if (err){ err.textContent = 'Could not add the ' + (C.noun || 'add-on') + '. Please add it from the cart.'; err.style.display = 'block'; }
      });
    }, 900);
  }, true);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', pass);
  else pass();
  setInterval(pass, 800);
})();

/* The frame and the case are add-ons, not catalogue items: no link anywhere
   on the site (cart lines included) may open their product pages. Hrefs are
   stripped as they appear, and a capture-phase blocker catches the window
   between a drawer rebuild and the next sweep. Their PDPs also carry the
   redirect template server-side. */
(function(){
  if (window.pgNoAddonLinks) return; window.pgNoAddonLinks = 1;
  var MARKS = ['30x40cm-frame', 'r36s-protective-case'];
  function strip(){
    for (var i = 0; i < MARKS.length; i++){
      document.querySelectorAll('a[href*="' + MARKS[i] + '"]').forEach(function(a){
        /* href STAYS: pg-drawer, pg-chips and pg-frame-add all identify these
           lines by it. Only the navigation is disabled. */
        a.style.setProperty('pointer-events', 'none', 'important');
        a.style.setProperty('cursor', 'default', 'important');
        a.style.setProperty('text-decoration', 'none', 'important');
      });
    }
  }
  document.addEventListener('click', function(e){
    var a = e.target && e.target.closest && e.target.closest('a[href*="30x40cm-frame"], a[href*="r36s-protective-case"]');
    if (a){ e.preventDefault(); e.stopPropagation(); }
  }, true);
  /* A PACK LINE IN THE CART LINKS TO THE CONSOLE PAGE. The href itself is
     left alone -- pg-cart-tune, pg-drawer and pg-cart-variants all identify a
     pack row by it -- so only the navigation is redirected. Without this the
     tap landed on the pack's own product page, which grew the generic
     four-tier ladder ("five different bundle deals"). The pack pages also
     carry product.redirect-console server-side, for links this cannot see. */
  document.addEventListener('click', function(e){
    var a = e.target && e.target.closest && e.target.closest('a[href*="/products/r36s-duo-pack"], a[href*="/products/r36s-trio-pack"]');
    if (!a) return;
    e.preventDefault(); e.stopPropagation();
    window.location.href = '/products/handheld-game-console';
  }, true);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', strip);
  else strip();
  setInterval(strip, 900);
})();
;
/* pg-theme-css */
/* Review photo rail loop (2026-09-22, owner: "the scroll needs to loop back to the beginning for all the products" - the buyer-photo rail under the tiles, not the gallery). The rail is a native scroll-snap row; the cards are laid out three times and the scroll position is kept inside the middle copy, so swiping past either end lands on the same photos again with no dead end. The story's flex 'order' (lead/last keys) is baked into DOM order first, or the copies would interleave. */
(function(){
  var SEL = '#pgx .pg-rhs-rail, #pgx .pg-p2s-rail, #pgx .pg-obs-rail, #pgx .pg-fsps-rail';
  function arm(r){
    if (r.getAttribute('data-pg-loop')) return;
    var kids = [].slice.call(r.children).filter(function(k){ return k.nodeType === 1; });
    if (kids.length < 2) return;
    r.setAttribute('data-pg-loop', '1');
    kids = kids.map(function(k, i){ return {k: k, i: i, o: parseInt(getComputedStyle(k).order, 10) || 0}; })
      .sort(function(a, b){ return a.o - b.o || a.i - b.i; }).map(function(x){ return x.k; });
    kids.forEach(function(k){ k.style.order = ''; r.appendChild(k); });
    var n = kids.length;
    for (var c = 0; c < 2; c++) kids.forEach(function(k){ var cl = k.cloneNode(true); cl.setAttribute('aria-hidden', 'true'); cl.setAttribute('tabindex', '-1'); cl.setAttribute('data-pg-clone', '1'); r.appendChild(cl); });
    var W = 0;
    function measure(){ W = r.children[n].offsetLeft - r.children[0].offsetLeft; return W; }
    function put(x){ r.style.scrollBehavior = 'auto'; r.scrollLeft = x; r.style.scrollBehavior = ''; }
    measure(); put(W);
    r.addEventListener('scroll', function(){
      if (!W && !measure()) return;
      var x = r.scrollLeft;
      if (x < W * 0.5) put(x + W); else if (x >= W * 1.5) put(x - W);
    }, {passive: true});
    window.addEventListener('resize', function(){ var x = r.scrollLeft, old = W; if (measure() && old) put(x / old * W); });
    setTimeout(function(){ var old = W; if (measure() !== old) put(W); }, 1200);
  }
  function boot(){ document.querySelectorAll(SEL).forEach(arm); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  setTimeout(boot, 800); setTimeout(boot, 2500);
})();
